import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';

interface IGetAddStepDrawerObjectProps {
  formObject: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
  resetStepDto: () => void;
}

export const addStepDrawerObject = ({ formObject, toggleVisibility, action, resetStepDto }: IGetAddStepDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.dacScenarios.steps.add.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      resetStepDto?.();
    },
    actions: [
      {
        label: 'settings.dacScenarios.add.add',
        onClick: () => action?.(),
      },
      {
        label: 'settings.dacScenarios.add.cancel',
        onClick: () => {
          toggleVisibility?.();
          resetStepDto?.();
        },
        variant: 'secondary',
      },
    ],
  };
};
